firebird.factory('videoInitializeService', [
    '$rootScope',
    '$timeout',
    '$window',
    'logService',
    'attendeeService',
    'connectivityService',
    'phoneConferenceService',
    'socketService',
    'helperService',
    'configService',
    'avDeviceService',
    'meetingService',
    'analyticsWrapperService',
    'brandingService',
    'localizationService',
    'cookieService',
    'videoFilterService',
    'videoGlobalService',
    'executionEnvironmentEnum',
    function (
        $rootScope,
        $timeout,
        $window,
        logService,
        attendeeService,
        connectivityService,
        phoneConferenceService,
        socketService,
        helperService,
        configService,
        avDeviceService,
        meetingService,
        analyticsWrapperService,
        brandingService,
        localizationService,
        cookieService,
        videoFilterService,
        videoGlobalService,
        executionEnvironmentEnum
    ) {
        var service = {
            initialize: initialize
        };

        var self, $scope;

        const logger = logService.createLoggerWithSource('[videoroomCtrl] videoInitializeService');

        return service;

        function initialize(selfParam) {
            self = selfParam;
            $scope = videoGlobalService.data.$scope;

            if (videoGlobalService.test) {
                $window = videoGlobalService.data.$window;
            }

            self.init = init;
            self.finalizeInit = finalizeInit;
            self.onJanusInit = onJanusInit;
            self.toggleDelay = toggleDelay;

            self.name = attendeeService.getScreenName();
            self.email = attendeeService.getEmail();
            self.attendantId = attendeeService.getAttendantId();
            self.attendantLoginId = attendeeService.getAttendantLoginId();
            self.isHost = attendeeService.getIsHost(true);

            self.delayShowNav = false;

            self.showAlert = showAlert;
            self.hideAlert = hideAlert;

            self.getLocalizationClass = getLocalizationClass;

            //Exposing this function to prevent it from being called after every unit test
            self.onScopeDestroyed = onScopeDestroyed;

            // listen for destroy and hangup events, to close the call.
            $scope.$on('$destroy', function () {
                self.onScopeDestroyed();
            });
            $scope.$on('hang-up-verto', onScopeDestroyed);

            $scope.$on('initiate-janus-call', onInitiateJanusCall);

            // This can be set via URL param, or detect VDI, and reflects the value from helperService.
            self.VDIRef = undefined;

            // whether to reuse SDP from videoroom plugin to SIP plugin part?
            self.reuseScreenSDP = {
                enable: true,
                saved: null
            };
        }

        // initialize the component.
        function init() {
            videoFilterService.initialize(self.msgflow, self.showAlert);
            connectivityService.setConnectionType('janus');

            $timeout(function () {
                //Angular doesnt support "ng-change" for file upload inputs... so jquery listener needed here
                $window.$('#videoroom-fileplay-upload').change(self.onFilePlayInputChange);
                $window.$('#videoroom-fileplay-upload').click(function (event) {
                    event.stopPropagation();
                });
            });
        }

        function toggleDelay() {
            self.delayShowNav = true;
            $timeout(function () {
                self.delayShowNav = false;
            }, 333);
        }

        function onInitiateJanusCall(e, data) {
            logger.log('videoroomCtrl - onInitiateJanusCall');

            connectivityService.sendIceConnStateToServer('connecting', self.getJanusConnectionState());
            self.showConnectingOverlay();

            self.updateConnTimeDevice();

            //If no devices found, continue with making call without permissions checks
            if (!avDeviceService.hasMicrophone() && !avDeviceService.hasCamera()) {
                logger.log("videoroomCtrl no devices found, using iceTransportPolicy 'relay'");
                self.iceTransportPolicy = 'relay';

                self.finalizeInit();
                return;
            }

            if (data && data.devicesPreviewedBeforeJoin) {
                logger.log('videoroomCtrl devices previewed before joining... skipping startDevicePermissionsFlow');

                if (avDeviceService.audioOrVideoBlocked()) {
                    logger.log("videoroomCtrl device permissions denied, using iceTransportPolicy 'relay'");
                    self.iceTransportPolicy = 'relay';
                }

                self.updateConnTimeData('joinFlow', data.durationMs);
                self.finalizeInit();
            } else {
                //Checks initial state of a/v device permissions
                avDeviceService
                    .startDevicePermissionsFlow()
                    .catch(function (err) {
                        // catch required for unit testing
                        logger.error('onInitiateJanusCall', 'device startDevicePermissionsFlow', err);
                    })
                    .finally(function () {
                        //By this point, user should have allowed or denied permissions
                        if (avDeviceService.audioOrVideoBlocked()) {
                            logger.log("videoroomCtrl device permissions denied, using iceTransportPolicy 'relay'");
                            self.iceTransportPolicy = 'relay';
                        }

                        self.finalizeInit();
                    });
            }
        }

        function finalizeInit() {
            logger.debug('videoroomCtrl finalizeInit');

            self.updateAudioOutputDevice();

            // initialize the Janus client stack if not already initialized.
            if (!$window.Janus.initCalled) {
                $window.Janus.initCalled = true;
                var debug = helperService.getQueryParameter('janusDebug') == 'all' ? 'all' : ['warn', 'error'];
                var detectIceChange = configService.getValue('detectIceChange') === 'true';
                $window.Janus.detectIceChange = detectIceChange;
                var deviceTimeout = parseInt(helperService.getQueryParameter('deviceTimeout') || '0');
                if (deviceTimeout > 0) {
                    $window.Janus.deviceTimeout = deviceTimeout;
                }
                detectVDI();
                if (self.VDIRef.getVdiType() !== executionEnvironmentEnum.NonVDI) {
                    debug = 'all';
                }
                const janusLogger = logService.createLoggerWithSource('[Janus]');
                $window.Janus.logger = janusLogger;
                $window.Janus.init({ debug: debug, callback: self.onJanusInit });
            }
        }

        function detectVDI() {
            if (helperService.getVDIRef()) {
                self.VDIRef = helperService.getVDIRef();
                if (self.VDIRef.reuseScreenSDP && !self.reuseScreenSDP.enable) {
                    self.reuseScreenSDP.enable = true;
                }
            }
        }

        // destroy the component.
        function onScopeDestroyed() {
            if (self.screenshare || self.screenshareState) {
                self.stopScreenShare(false, 'scope destroyed');
            }

            self.leaveConference();
        }

        // Once Janus stack is loaded, perform other initialization and join the conference.
        // Two Janus plugins (videoroom and SIP) are used in this component. However, if
        // newplugin is set, then a single plugin (anymeeting) is used which combines both the
        // functions.
        function onJanusInit() {
            logger.debug('videoroomCtrl - onJanusInit');

            // TODO: check if jquery.resize.js is efficient for detecting DOM element resize?
            $window.$('#videoroom-videos').resize(onWindowResize);

            self.parseFeatureFlagsParams();

            $window.$('#videoroom-allhands-previous').click(function (event) {
                self.toggleDelay();
                if (self.layoutPage) {
                    self.onLayoutPageGoto('previous');

                    analyticsWrapperService.eventTrack('Meeting - All Webcams View Layout Previous Page Clicked');
                }
            });
            $window.$('#videoroom-allhands-next').click(function (event) {
                self.toggleDelay();
                if (self.layoutPage) {
                    self.onLayoutPageGoto('next');

                    analyticsWrapperService.eventTrack('Meeting - All Webcams View Layout Next Page Clicked');
                }
            });

            // TODO: following code is useful to testing layouts of many videos.
            if (self.showTestLayout()) {
                // if handled, do not proceed.
                self.hasTestLayout = true;
                return;
            }

            self.applyQueryParameters();

            self.setCustomImageStyles();

            // populate the SIP plugin's from/to address. The from address (localuri) is the caller or
            // attendee, and the to address (remoteuri) is the conference.
            var phoneInfo = phoneConferenceService.getPhoneData();
            self.localuri = 'sip:' + attendeeService.getEmail();
            self.remoteuri = 'sip:1_firebird_' + phoneInfo.phoneConferenceUserID + '@' + phoneInfo.server;

            // the screen name is not used by SIP plugin, but only by videoroom plugin.
            self.myusername = attendeeService.getScreenName();

            // videoroom plugin needs a room identifier.
            // TODO: enable password authentication.
            self.myroom = parseInt(phoneInfo.phoneConferenceUserID);

            // this assumes that Janus is co-located with FreeSwitch server.
            // prefer websocket, and fallback to long polling.
            self.serverhost = phoneInfo.server;
            self.server = ['wss://' + phoneInfo.server + '/8188'];

            if (configService.getValue('enableWssToHttpsFallback') === 'true') {
                self.server.push('https://' + phoneInfo.server + '/janus');
            }

            if (self.msgflow) {
                // msg flow logging
                self.msgflow.other = `JS.${phoneInfo.server.split('.')[0]}`;
                self.msgflow.self = `C.${self.attendantId}`;
                // self.msgflow.setSelf('C.' + self.attendantId + '.' + self.attendantLoginId); // TODO: not needed
                $window.Janus.msgflow = self.msgflow;
            }

            if (!helperService.isElectron()) {
                // dispatch client-end on tab close. electron app traps this in firebirdCtrl.
                $window.addEventListener('beforeunload', function (event) {
                    socketService.beforeunload(true);
                    self.destroyJanus('leave');
                    if (self.layoutPopout) {
                        self.onPopoutLeaveConf();
                    }
                });
            }

            self.startSpeedTest('onJanusInit', function (firstTime) {
                logger.log('videoroomCtrl - return from speed test: firstTime = ' + firstTime);
                if (firstTime) {
                    if (self.sendStatsInterval > 0) {
                        self.startSendStats();
                    }
                    videoFilterService.initVideoFilter();
                    // join the conference.
                    self.joinConference();
                } else {
                    // update viewed substreams
                    self.simulcastReason = 'startSpeedTest callback';
                    $window.$('#videoroom-videos > div:not(.audioonly)').each(function (index, div) {
                        self.setSimulcast(div);
                    });
                }
            });

            if (cookieService.getObject('attendee-favorites-' + meetingService.getMeetingCode())) {
                var list = cookieService.getObject('attendee-favorites-' + meetingService.getMeetingCode());
                Object.keys(list).forEach(function (attendantId) {
                    self.onToggleLayoutPin(attendantId, list[attendantId]);
                });
            }
        }

        // When the videoroom component is resized, either due to window resize or other changes in
        // the client, then re-do the layout. To avoid too many layout changes, the update is
        // delayed briefly, to collate all the other resize events during that interval.
        function onWindowResize() {
            if (self.resizeTimer) {
                $timeout.cancel(self.resizeTimer);
            }

            var timeout = self.layoutPage && !self.layoutPageData.animateResize ? 10 : 500; // no need to wait if no animation
            self.resizeTimer = $timeout(function () {
                self.resizeTimer = null;
                if (self.layoutPage && !self.layoutPageData.animateResize) {
                    self.disableAnimationOnAllVideos(function () {
                        self.updateVideosLayout();
                        if (self.adjustOnWindowSize) {
                            self.simulcastReason = 'onWindowResize without animation';
                            self.setSimulcastForAllVideos();
                        }
                    });
                } else {
                    self.updateVideosLayout();
                    if (self.adjustOnWindowSize) {
                        self.simulcastReason = 'onWindowResize with animation';
                        self.setSimulcastForAllVideos();
                    }
                }
            }, timeout);
        }

        /**
         * Shows an alert. If confirmCallback is supplied, then cancel button is shown, and callback is invoked when ok or cancel is clicked.
         * NOTE: should be replased with UNI api in the future.
         * @param msgTitle {string} Message title
         * @param msgTxt {string} Message text
         * @param isHtml {boolean} Use html
         * @param confirmCallback {function} Confirm callback
         * @param overrides {object} Use to override default values
         */
        function showAlert(msgTitle, msgTxt, isHtml, confirmCallback, overrides = {}) {
            if (helperService.getIsMeetingEnding()) {
                logger.log('videoroomCtrl returning from showAlert due to meeting ending');
                return;
            }

            if (!self.VDIRef.showContentsOnTopOfVideo) {
                // VDI - Hide video stream in device selection modal when alerts popup
                $rootScope.$broadcast('toggle-modal-on-preview', true);
            }

            if (helperService.getIsRedesign()) {
                const {
                    cancelText = localizationService.translate('COMMON.CANCEL_TEXT'),
                    okText = localizationService.translate('COMMON.OK_TEXT'),
                    closeText = localizationService.translate('COMMON.CLOSE_TEXT'),
                    imageUrl = 'img/redesign/modal/pop-up-pic-warning.svg',
                    customClass
                } = overrides;

                const closeButtonHtml =
                    '<button class="sweetalert-close-x" onclick="window.swal.close();" tabindex="3"><img src="img/redesign/icons/close-big.svg"></img></button>';

                $window.swal(
                    {
                        title: closeButtonHtml + msgTitle,
                        text: msgTxt || '',
                        showCancelButton: !!confirmCallback,
                        showConfirmButton: true,
                        cancelButtonText: confirmCallback ? cancelText : undefined,
                        confirmButtonText: confirmCallback ? okText : closeText,
                        confirmButtonColor: brandingService.getBaseColor(),
                        allowOutsideClick: false,
                        html: true,
                        imageUrl,
                        customClass
                    },
                    confirmCallback || undefined
                );
            } else {
                $window.swal(
                    {
                        title: msgTitle,
                        text: msgTxt || '',
                        type: 'warning',
                        showCancelButton: !!confirmCallback,
                        showConfirmButton: true,
                        confirmButtonText: 'OK',
                        confirmButtonColor: brandingService.getBaseColor(),
                        allowOutsideClick: false,
                        html: isHtml
                    },
                    confirmCallback || undefined
                );
            }
        }

        function hideAlert() {
            // VDI - Show video stream in device selection modal when alerts are closed.
            if (!self.VDIRef.showContentsOnTopOfVideo) {
                $rootScope.$broadcast('toggle-modal-on-preview', false);
            }
            $window.swal.close();
        }

        function getLocalizationClass() {
            return localizationService.getLocalization().replace('-', '').toLowerCase();
        }
    }
]);
